export type FileError = { code: string } | string;

export function createFileError(message: string): FileError {
    return { code: message };
}
